
import _ from "lodash";
import VueSelect from "vue-select";
import TagOutline from "vue-material-design-icons/TagOutline.vue";
import CloseCircleOutline from "vue-material-design-icons/CloseCircleOutline.vue";
import "vue-select/dist/vue-select.css";

export default {
  name: "ListaPrecoServicoSelect",
  components: {
    VueSelect,
    TagOutline,
    CloseCircleOutline,
  },
  props: {
    buttonLabel: {
      type: String,
      default: "Lista de preços",
    },
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      listas: [],
    };
  },
  methods: {
    abrirModal() {
      this.$bvModal.show("modal-lista-preco-servico");
    },
    onSearch(search, loading) {
      loading(true);
      this.buscarListas(search, loading);
    },
    buscarListas: _.debounce(async function (search, loading) {
      await this.carregarListas(search);
      loading(false);
    }, 350),
    async carregarListas(descricao) {
      const { data } = await this.$http.post("/servicos/lista-preco/ativas", {
        descricao,
      });
      this.listas = data;
    },
  },
};
